module.exports = __webpack_public_path__ + "neye_closed_icon.svg";